﻿import {isNullOrEmpty, translation} from "@2d-front-monorepo/core";
import {Message} from "@2d-front-monorepo/design-library";
import {Permits} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";

import {JSX} from "react";
import {useParams} from "react-router";
import {PermitsBackButtonFrame} from "../../components/PermitsBackButton";
import {getGlobalContext} from "../../hooks/getGlobalContext";
import {usePermits} from "../../hooks/usePermits";
import PermitListComponent from "./ViewComponents/PermitListComponent";
import {RenewGroupComponent} from "./ViewComponents/RenewGroupComponent";

export default function PermitsGroup(): JSX.Element {
	const permitsState = usePermits();
	const {groupName} = useParams();
	const {installation} = getGlobalContext();
	const filtered = Permits.getFilteredPermits(permitsState.permits, groupName!);

	if (isNullOrEmpty(groupName)) {
		return <Message title={{text: translation(PermitTranslations.error__missing_group_name)}} type="error"/>;
	}

	return (
		<>
			<h1>{translation(PermitTranslations.summary_page__title)}</h1>
			<hr/>
			<RenewGroupComponent permits={filtered.map(x => x.permit)} skipSingle={true}/>
			<PermitListComponent installation={installation} grouped={filtered} {...permitsState} />
			<PermitsBackButtonFrame/>
		</>
	);
}
